import React from 'react';
import { SimpleGrid } from '@chakra-ui/react';
import {
	FaUsers,
	FaBullhorn,
	FaAddressBook,
	FaEnvelope,
	FaProjectDiagram,
	FaUserPlus,
	FaFileInvoiceDollar,
	FaChartLine,
} from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { StatTile } from './dashboardShared';

const KeyMetrics = ({ stats }) => {
	const navigate = useNavigate();

	const tiles = [
		{
			title: 'Team members',
			value: stats.totalEmployees,
			subtitle: 'People in your company',
			icon: FaUsers,
			gradient: 'linear(135deg, teal.400, teal.600)',
			bgGradient: 'linear(teal.400, teal.600)',
			onClick: () => navigate('/employees'),
		},
		{
			title: 'Active projects',
			value: stats.activeProjects,
			subtitle: `${stats.totalProjects} total`,
			icon: FaProjectDiagram,
			gradient: 'linear(135deg, blue.400, blue.600)',
			bgGradient: 'linear(blue.400, blue.600)',
			onClick: () => navigate('/projects'),
		},
		{
			title: 'Open leads',
			value: stats.openLeads,
			subtitle: `${stats.totalLeads} in pipeline`,
			icon: FaUserPlus,
			gradient: 'linear(135deg, orange.400, orange.600)',
			bgGradient: 'linear(orange.400, orange.600)',
			onClick: () => navigate('/leads'),
		},
		{
			title: 'Active campaigns',
			value: stats.activeCampaigns,
			subtitle: `${stats.totalCampaigns} total`,
			icon: FaBullhorn,
			gradient: 'linear(135deg, green.400, green.600)',
			bgGradient: 'linear(green.400, green.600)',
			onClick: () => navigate('/campaigns'),
		},
		{
			title: 'Total contacts',
			value: stats.totalContacts.toLocaleString(),
			subtitle: `${stats.contactLists} lists`,
			icon: FaAddressBook,
			gradient: 'linear(135deg, purple.400, purple.600)',
			bgGradient: 'linear(purple.400, purple.600)',
			onClick: () => navigate('/contacts'),
		},
		{
			title: 'Emails delivered',
			value: stats.emailsSent.toLocaleString(),
			subtitle: 'Across all campaigns',
			icon: FaEnvelope,
			gradient: 'linear(135deg, cyan.400, cyan.600)',
			bgGradient: 'linear(cyan.400, cyan.600)',
			onClick: () => navigate('/campaigns'),
		},
		{
			title: 'Unpaid invoices',
			value: stats.unpaidInvoices,
			subtitle: `${stats.totalInvoices} invoices`,
			icon: FaFileInvoiceDollar,
			gradient: 'linear(135deg, red.400, red.600)',
			bgGradient: 'linear(red.400, red.600)',
			onClick: () => navigate('/invoices'),
		},
		{
			title: 'Email open rate',
			value: `${stats.openRate.toFixed(1)}%`,
			subtitle: `${stats.clickRate.toFixed(1)}% click rate`,
			icon: FaChartLine,
			gradient: 'linear(135deg, pink.400, pink.600)',
			bgGradient: 'linear(pink.400, pink.600)',
			onClick: () => navigate('/campaigns'),
		},
	];

	return (
		<SimpleGrid columns={{ base: 1, sm: 2, lg: 4 }} spacing={4}>
			{tiles.map((tile) => (
				<StatTile key={tile.title} {...tile} />
			))}
		</SimpleGrid>
	);
};

export default KeyMetrics;
